/* eslint-disable import/prefer-default-export */
import { Feature } from '../util/featureFlags';
import { useShopConfig } from './shopConfig';
import { useEnabledCustomerExperiences } from './useEnabledCustomerExperiences';
import { useFeatureFlags } from './useFeatureFlags';

export function useIsShopSideLaunched() {
  const { allowBuy } = useEnabledCustomerExperiences();

  const { shopLaunchDate } = useShopConfig();
  const isForceShopLaunch = useFeatureFlags(Feature.ForceShopLaunch);

  const currentDate = new Date();
  const launchDate = new Date(shopLaunchDate);

  if (isForceShopLaunch) {
    // Site launch experience is being forced through feature flag
    return true;
  }

  // Site has launched if the launch date has surpassed. If the launch date is not defined in the
  // shop config, we default to the site's launched experience.
  const hasLaunched = !shopLaunchDate || currentDate > launchDate;

  // Site must have the "Buy" experience enabled for its shop side to be active.
  return allowBuy && hasLaunched;
}
